export function useUserFromToken() {
    const token = localStorage.getItem('@athenas:accessToken');
  
    if (!token) throw new Error('Invalid token!');
    const tokenParts = token.split('.');
    if (tokenParts.length !== 3) throw new Error('Invalid token format!');
  
    const payload = JSON.parse(atob(tokenParts[1]));
    return { userId: payload.userId };
}